const is = require('../helper/is')
const HTML = {}

/**
 * DOM element creation abstraction
 * @param {String} elementType
 * @param {{}} [extraParameters]
 * @param {Array} [children]
 * @returns {HTMLElement}
 */
HTML.make = function (elementType, extraParameters, children) {
  const element = document.createElement(elementType)
  if (is.checkVariable(extraParameters) && is.getAmountOfKeys(extraParameters) > 0) {
    for (const key in extraParameters) {
      if (extraParameters.hasOwnProperty(key)) {
        element.setAttribute(key,extraParameters[key])
      }
    }
  }

  if(is.array(children)) {
    children.forEach(function (child) {
      if(is.string(child)){
        element.appendChild(HTML.text(child))
      } else if (is.checkVariable(child)) {
        element.appendChild(child)
      }
    })
  }

  return element
}

/**
 * Converts string to text node
 * @param {String} string
 * @returns {Text}
 */
HTML.text = function (string) {
  return document.createTextNode(string)
}

/**
 * Generates select input with list of children
 * @param optionArray
 * @param extraParameters
 * @param {String|int} [selectedValue]
 * @returns {HTMLElement}
 */
HTML.select = function (optionArray, extraParameters, selectedValue) {
  const selectInput = HTML.make('select', extraParameters)
  if (optionArray instanceof Array) {
    for (let i = 0; i < optionArray.length; i++) {
      const options = optionArray[i]

      // NUEVO: Soportar estructura { value: "...", text: "...", preview: "..." }
      if (options.hasOwnProperty('value') && options.hasOwnProperty('text')) {
        const opt = HTML.make('option', { 'value' : options.value }, [HTML.text(options.text)])
        if (selectedValue && selectedValue === options.value) {
          opt.selected = true
        }
        selectInput.appendChild(opt)
      } else {
        // ORIGINAL: Estructura { "key": "value" }
        for (const key in options) {
          if (options.hasOwnProperty(key)) {
            const opt = HTML.make('option', { 'value' : key }, [HTML.text(options[key])])
            if (selectedValue && selectedValue === key) {
              opt.selected = true
            }
            selectInput.appendChild(opt)
          }
        }
      }
    }
  } else {
    for (const k in optionArray) {
      if (optionArray.hasOwnProperty(k)) {
        const option = HTML.make('option', { 'value' : k }, [HTML.text(optionArray[k])])
        if (selectedValue && selectedValue === k) {
          option.selected = true
        }
        selectInput.appendChild(option)
      }
    }
  }

  return selectInput
}

/**
 * This method clears every children a parent has
 * @param {HTMLElement|Node} target
 * @param {boolean} [alsoParent] - will delete the element if true
 */
HTML.destroyChildrenOf = function (target, alsoParent) {
  try {
    while (target.firstChild) {
      target.removeChild(target.firstChild)
    }

    if (alsoParent) {
      target.parentNode.removeChild(target)
    }
  } catch(error) {
    // Error
  }
}

/**
 * Dives deep into the DOM, and fires a callback for each element
 * @param {HTMLElement} rootElement
 * @param {Function} action
 */
HTML.refactor = function (rootElement, action) {
  const children = rootElement.children
  for (let i = 0; i < children.length; i++) {
    if (children[i].children.length > 0) {
      this.refactor(children[i], action)
    }
    if (action != null)
      action(children[i])
  }
}

/**
 * Same as refactor function, but evaluating parameter first (optimized)
 * @param {HTMLElement} rootElement
 * @param {Object} attribute
 * @param {Function} action
 */
HTML.refactorForAttribute = function (rootElement, attribute, action) {
  let attributeName   = null
  let attributeValue  = null
  for (const key in attribute) {
    if (attribute.hasOwnProperty(key)) {
      attributeName = key
      attributeValue = attribute[key]
    }
  }

  const children = rootElement.children
  for (let i = 0; i < children.length; i++) {
    if (children[i].children.length > 0) {
      this.refactorForAttribute(children[i], attribute, action)
    }
    if (action != null && children[i].getAttribute(attributeName) === attributeValue) {
      action(children[i])
    }
  }
}

exports.HTML = HTML
export default HTML
